module.exports = __webpack_public_path__ + "img/banner-1.2c91c2fc.png";